var map = {
	"./en-au": 94073,
	"./en-au.js": 94073,
	"./en-ca": 11387,
	"./en-ca.js": 11387,
	"./en-gb": 41386,
	"./en-gb.js": 41386,
	"./en-ie": 53537,
	"./en-ie.js": 53537,
	"./en-il": 67050,
	"./en-il.js": 67050,
	"./en-in": 3008,
	"./en-in.js": 3008,
	"./en-nz": 96963,
	"./en-nz.js": 96963,
	"./en-sg": 14865,
	"./en-sg.js": 14865,
	"./zh-cn": 61329,
	"./zh-cn.js": 61329,
	"./zh-hk": 13005,
	"./zh-hk.js": 13005,
	"./zh-mo": 47696,
	"./zh-mo.js": 47696,
	"./zh-tw": 85861,
	"./zh-tw.js": 85861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79844;